// TBD: come up better name. What is the braintree card? Is it provider or another super service?
var StripeCardOurPay = (function (PaymentProviderBase, CheckoutSettings, StripeHelper) {

    var StripeCardOurPay = PaymentProviderBase.extend({
        type: 'mypay',
        paymentOption: CheckoutSettings.PaymentOption.OurPay,
        _supportedTypes: stripeSupportedTypes.card,
        _supportedOrderTypes: stripeSupportedOrderTypes.card,
        _supportedProviderType: CheckoutSettings.PaymentOption.Stripe,

        initialize: function (attrs, opts) {

            this.hideErrors = !!opts.hideErrors;
            this._logger = opts.logger;

            attrs._getStripe().done(_.bind(function (stripe) {
                this.stripe = stripe;
            }, this));

        },

        prepayment: function () {
            return this.stripe.getPayload()
                .fail(function(result) {
                    if (result.error && result.error.message) {
                        alert(result.error.message);
                    }
                });
        },

        complete: function (paymentMethodId) {

            if (typeof (paymentMethodId) === 'object') {
                paymentMethodId = paymentMethodId.Token;
            }

            var transactionData = {
                paymentType: 'mypay',
                provider: 'stripe',
                selectedPaymentOption: this.paymentOption,
                paymentMethodId: paymentMethodId
            };

            this._logger && this._logger('Stripe');

            var _method = _.bind(this._createPaymentTransaction, this);
            var $result = new $.Deferred();

            _method(transactionData, { wait: true, preventDoubleRequests: true, hideErrors: this.hideErrors })
                .then(this.stripe.handleServerResponce)
                .then(function(result) {
                    if (typeof (result) === "string") {
                        var transactionData = {
                            paymentType: 'mypay',
                            provider: 'stripe',
                            selectedPaymentOption: this.paymentOption,
                            paymentIntentId: result
                        };
                        return _method(transactionData,
                            { wait: true, preventDoubleRequests: true, hideErrors: this.hideErrors });
                    }
                    return result;
                })
                .then(function(result) {
                    if (!result.Result || !result.Value.isPaid || result.Value.response === 'basket_changed') {
                        $result.reject(result);
                    } else {
                        $result.resolve(result);
                    }
                })
                .fail($result.reject);
            return $result.promise();
        },
        _fireError: function (err) {
            // TBD: PAPI must return message with Rejection Codes
            // TBD: no untrusted code

            if (!err.Message) {
                switch (err.Value.rejectionCode) {
                    case CheckoutSettings.MyPayRejectionCodes.outOfRange:
                        //err.Message = 'Only available for orders between £100 and £500';
                        err.Message = kos.getPageTemplate('_OurPayRejectionOutOfRange');
                        break;
                    case CheckoutSettings.MyPayRejectionCodes.exceededDebtLimit:
                        //err.Message = 'You can\'t pay with OurPay now because you exceed your credit limit. You could pay with OurPay after next payment on the earlier purchase.';
                        err.Message = kos.getPageTemplate('_checkoutMyPayPayExceedLimit').format('OurPay');
                        break;
                    case CheckoutSettings.MyPayRejectionCodes.invalidPaymentMethod:
                        //err.Message = 'we don\'t support your current payment method for it. If you choose another payment method you could use it.';
                        err.Message = kos.getPageTemplate('_checkoutMyPayPayInvalidPaymentMethod').format('OurPay');
                        break;
                }
            }

            this._checkoutStoreDispatcher.trigger('ourpay-error', err);
        }
	});

    return StripeCardOurPay;
})(PaymentProviderBase, CheckoutSettings, StripeHelper);
